function isHexValue(symbol) {
  return (symbol >= "0" && symbol <= "9") || (symbol >= "a" && symbol <= "f") || (symbol >= "A" && symbol <= "F");
}

export class ColorConverter {
  constructor() {}

  static converColorToHex(rgb) {
    const hexColor = number => {
      let hex = Number(number).toString(16);
      if (hex.length < 2) {
        hex = "0" + hex;
      }
      return hex;
    };

    let red = hexColor(rgb[0]);
    let green = hexColor(rgb[1]);
    let blue = hexColor(rgb[2]);
    return "#" + red + green + blue;
  }

  static convertWebglRgbaToInt(color) {
    if (color === undefined || !Array.isArray(color) || color.length != 4) {
      return {
        value: undefined,
        success: false
      };
    }
    let parsedColor = [0, 0, 0, 0];
    for (let i = 0; i < 4; i++) {
      parsedColor[i] = Math.round(color[i] * 255);
    }
    return {
      value: parsedColor,
      success: true
    };
  }

  static convertWebglRgbaToHex(color) {
    if (color === undefined || !Array.isArray(color) || color.length != 4) {
      return {
        value: undefined,
        success: false
      };
    }
    let parsedColor = "#";
    for (let i = 0; i < 4; i++) {
      let hex = Number(Math.round(color[i] * 255)).toString(16);
      if (hex.length < 2) {
        hex = "0" + hex;
      }
      parsedColor += hex;
    }
    return {
      value: parsedColor,
      success: true
    };
  }

  static convertToWebglRgba(color) {
    if (color === undefined) {
      return {
        value: undefined,
        success: false
      };
    }
    let parsedColor = [0, 0, 0, 1];
    if (Array.isArray(color)) {
      // format: [255, 255, 255, 255] (RGBA, every value from 0 to 255) | [255, 255, 255] (RGB, every value from 0 to 255)
      if (color.length < 3 || color.length > 4) {
        return {
          value: undefined,
          success: false
        };
      }
      for (let i = 0; i < color.length; i++) {
        if (isNaN(color[i])) {
          return {
            value: undefined,
            success: false
          };
        }
        parsedColor[i] = color[i] / 255.0;
      }
      return {
        value: parsedColor,
        success: true
      };
    } else if (typeof color === "string") {
      // format: #FFFFFFFF (RGBA) or #FFFFFF (RGB, A = FF)
      const symbols = Array.from(color);
      if (symbols.length < 7 || symbols.length > 9 || symbols[0] != "#") {
        return {
          value: undefined,
          success: false
        };
      }
      for (let i = 1, j = 0; i < symbols.length; i += 2, j++) {
        if (!isHexValue(symbols[i]) || !isHexValue(symbols[i + 1])) {
          return {
            value: undefined,
            success: false
          };
        }
        let colorValue = parseInt(`${symbols[i]}${symbols[i + 1]}`, 16);
        parsedColor[j] = colorValue / 255.0;
      }
      return {
        value: parsedColor,
        success: true
      };
    }
    return {
      value: undefined,
      success: false
    };
  }

  static convertHexToRgb(hex) {
    var c;
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
      c = hex.substring(1).split("");
      if (c.length === 3) {
        c = [c[0], c[0], c[1], c[1], c[2], c[2]];
      }
      c = "0x" + c.join("");
      return [(c >> 16) & 255, (c >> 8) & 255, c & 255];
    }
    throw new Error("Bad Hex");
  }

  static rgbaToHex(rgb) {
    rgb = rgb.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i);
    return rgb && rgb.length === 4
      ? "#" +
          ("0" + parseInt(rgb[1], 10).toString(16)).slice(-2) +
          ("0" + parseInt(rgb[2], 10).toString(16)).slice(-2) +
          ("0" + parseInt(rgb[3], 10).toString(16)).slice(-2)
      : "";
  }
}
